.ux-iws-nb-content-header {
    display: block;
    overflow-x: hidden;
}

.ux-iws-nb-content-header__image {
    width: 100%;
    height: 0;
    padding-bottom: calc(2 / 3 * 100%);
    overflow: hidden;
    position: relative;

    @media (min-width: 768px) {
        padding-bottom: calc(1 / 4 * 100%);
    }

    img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.ux-iws-nb-content-header__box {
    margin: 80px 0;
    padding: 0 15px;
    box-sizing: border-box;
    max-width: 800px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-size: 28px;
        line-height: 1.2;
        margin-top: 0;
        margin-bottom: 10px;

        @media (min-width: 1024px) {
            font-size: 44px;
        }
    }

    @media (min-width: 568px) and (max-width: 767px) {
        padding-left: 30px;
    }
}
